import { createRoute } from '@/utils/routing'

export const OB_APPLICATIONS_ROUTE = 'open-banking-applications'
export const OB_PAYMENTS_ROUTE = 'open-banking-payments'
export const OB_INSTITUTIONS_ROUTE = 'open-banking-institutions'

export function createObApplicationsRoute (options = {}) {
  return createRoute(OB_APPLICATIONS_ROUTE, options)
}

export function createObPaymentsRoute (options = {}) {
  return createRoute(OB_PAYMENTS_ROUTE, options)
}

export function createObInstitutionsRoute (options = {}) {
  return createRoute(OB_INSTITUTIONS_ROUTE, options)
}
